var pagination = {
  'css': null,

  'exports': {
    onBeforeMount(props, state) {
        this.page = 1;
        this.total = 1;
        this.last = 1;
        this.prev = 1;
        this.next = 1;
        this.pager = [];
        this.setPager(props.pager);
    },

    onBeforeUpdate(props, state) {
        this.setPager(props.pager);
    },

    setPager(pager) {
        this.page = (typeof pager.page !== 'undefined') ? pager.page: 1;
        this.total = (typeof pager.total !== 'undefined') ? pager.total: 1;
        this.last = (typeof pager.last !== 'undefined') ? pager.last: 1;
        this.prev = (typeof pager.prev !== 'undefined') ? pager.prev: 1;
        this.next = (typeof pager.next !== 'undefined') ? pager.next: 1;

        let start = this.page  - 5
          , end = this.page  + 5
          , page = 0
          , list = [];

        if (0 >= start) {
            end = end + start * -1;
            start = 1;
        }
        if (this.last <= end) {
            end = this.last;
        }

        for (page=start; page < this.page; page++) {
            list.push({ page:page, curr:false });
        }
        list.push({ page:this.page, curr:true });

        for (page++; page <= end; page++) {
            list.push({ page:page, curr:false });
        }
        this.pager = list;
    },

    select(parent, e, page) {
        if (typeof parent.props === 'undefined') {
            return ;
        } else if (typeof parent.props.onpager === 'undefined') {
            return ;
        }
        parent.props.onpager(e, page);
    }
  },

  'template': function(template, expressionTypes, bindingTypes, getComponent) {
    return template(
      '<div class="ui pagination menu"><a expr33="expr33" class="icon item"><i class="angle double left icon"></i></a><a expr34="expr34" class="icon item"><i class="angle left icon"></i></a><a expr35="expr35"></a><a expr36="expr36" class="icon item"><i class="angle right icon"></i></a><a expr37="expr37" class="icon item"><i class="angle double right icon"></i></a></div><p expr38="expr38" class="pager_txt"> </p>',
      [{
        'redundantAttribute': 'expr33',
        'selector': '[expr33]',

        'expressions': [{
          'type': expressionTypes.EVENT,
          'name': 'onclick',

          'evaluate': function(scope) {
            return (e)=> scope.select(scope, e, 1);
          }
        }]
      }, {
        'redundantAttribute': 'expr34',
        'selector': '[expr34]',

        'expressions': [{
          'type': expressionTypes.EVENT,
          'name': 'onclick',

          'evaluate': function(scope) {
            return (e)=> scope.select(scope, e, scope.prev);
          }
        }]
      }, {
        'type': bindingTypes.EACH,
        'getKey': null,
        'condition': null,

        'template': template(' ', [{
          'expressions': [{
            'type': expressionTypes.TEXT,
            'childNodeIndex': 0,

            'evaluate': function(scope) {
              return scope.item.page;
            }
          }, {
            'type': expressionTypes.ATTRIBUTE,
            'name': 'class',

            'evaluate': function(scope) {
              return ['item', scope.item.curr ? ' active' : ''].join('');
            }
          }, {
            'type': expressionTypes.EVENT,
            'name': 'onclick',

            'evaluate': function(scope) {
              return (e)=> scope.select(scope, e, scope.item.page);
            }
          }]
        }]),

        'redundantAttribute': 'expr35',
        'selector': '[expr35]',
        'itemName': 'item',
        'indexName': null,

        'evaluate': function(scope) {
          return scope.pager;
        }
      }, {
        'redundantAttribute': 'expr36',
        'selector': '[expr36]',

        'expressions': [{
          'type': expressionTypes.EVENT,
          'name': 'onclick',

          'evaluate': function(scope) {
            return (e)=> scope.select(scope, e, scope.next);
          }
        }]
      }, {
        'redundantAttribute': 'expr37',
        'selector': '[expr37]',

        'expressions': [{
          'type': expressionTypes.EVENT,
          'name': 'onclick',

          'evaluate': function(scope) {
            return (e)=> scope.select(scope, e, scope.last);
          }
        }]
      }, {
        'redundantAttribute': 'expr38',
        'selector': '[expr38]',

        'expressions': [{
          'type': expressionTypes.TEXT,
          'childNodeIndex': 0,

          'evaluate': function(scope) {
            return ['全', scope.total, '件 ', scope.page, ' ／ ', scope.last, 'ページ'].join('');
          }
        }]
      }]
    );
  },

  'name': 'pagination-tag'
};

export default pagination;
